import React from 'react';
import { Stars } from './Stars';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-16 sm:px-8" data-id="element-270" data-mp="3krp0ysu8qbkj">
      <div className="mx-auto w-full max-w-6xl" data-id="element-271" data-mp="3fze45yusr5w7">
        <h2 className="text-center text-3xl font-extrabold tracking-tight text-neutral-900 sm:text-4xl" data-id="element-272" data-mp="3fy2whny8ddzt">
          What <span className="text-ember" data-id="element-273" data-mp="3ayi09lag3jqs">coaches</span> are saying
        </h2>
        <p className="mt-3 text-center text-sm font-bold text-neutral-800" data-id="element-274" data-mp="36zqzn46rtjyx">
          <Stars className="text-sm" data-id="element-275" data-mp="31zms43nubzku" /> 4.9/5 · 500+ coaches worldwide
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-276" data-mp="2x0jqkt72kbhm">
          {testimonials.map(testimonial => <figure key={testimonial.name} className="flex h-full flex-col rounded-2xl border border-neutral-200 bg-neutral-50 p-6" data-id="element-277" data-mp="2s2rxhvuoujbu">
              <div className="flex items-center gap-3" data-id="element-278" data-mp="qallu5trhlxn">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-ember text-xs font-extrabold text-white" data-id="element-279" data-mp="qb4zhacdpo5v">
                  {testimonial.initials}
                </span>
                <Stars className="text-sm" data-id="element-280" data-mp="m6cgpwqb0n1n" />
              </div>
              <blockquote className="mt-4 text-sm font-medium italic leading-relaxed text-neutral-800" data-id="element-281" data-mp="78k01190tslv">
                {testimonial.quote}
              </blockquote>
              <figcaption className="mt-auto pt-6" data-id="element-282" data-mp="zwfus0f15ag0">
                <span className="block text-sm font-bold text-neutral-900" data-id="element-283" data-mp="zwy2bt757b38">
                  {testimonial.name}
                </span>
                <span className="block text-xs text-neutral-500" data-id="element-284" data-mp="14xddce3yc6i1">
                  {testimonial.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}